module.exports = __webpack_public_path__ + "img/plus-circle-white.47aa7d94.svg";